exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-add-button[data-v-b8ba56d0]{height:50px}.custom-select[data-v-b8ba56d0]{line-height:32px;height:50px;border-radius:1px}", ""]);

// exports
